<template>
  <div>
    <h1 id="jump-to-header">{{heading || "View Asset to Image Link"}}</h1>
    <asset-image-link-update :id="id" :api_path="api_path"></asset-image-link-update>
  </div>
</template>

<script>
import AssetImageLinkUpdate from './AssetImageLinkUpdate.vue'

export default {
  components: {
    AssetImageLinkUpdate,
  },
  props: {
    id: {
      Type: String
    },
    heading: {
      Type: String
    },
    api_path: {
      Type: String
    }
  },
  data () {
    return {
    }
  },
  mounted() {
    const element = document.getElementById("jump-to-header")
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  }
}
</script>
